import { normalize as normalizeModel } from "src/engine/modules/model/helpers"
import selectEntities from "./entities"

/**
 * Select model redaction (redaction is a version of state, any changes inside
 * model's entities will increase its redaction)
 */
export default function entityItem(state, model) {
  const { name } = normalizeModel(model)
  const entitiesState = selectEntities(state)
  return entitiesState[name]
}
